/**
 * API Configuration
 * 
 * This file contains configuration for API endpoints
 * and environment-specific settings.
 */

// Base API URL configuration
const API_CONFIG = {
  // Local development environment
  development: {
    baseUrl: '/v1',
    useProxy: false,
  },
  // Production environment
  production: {
    baseUrl: '/v1', // Relative URL for production (assumes same-origin API)
    useProxy: false,
  }
};

// Determine current environment
const currentEnv = process.env.NODE_ENV || 'development';

// Export the configuration for the current environment
export const apiConfig = API_CONFIG[currentEnv];

// API endpoints
export const API_ENDPOINTS = {
  // Order related endpoints
  ORDER: {
    FETCH_INFO: '/pay/queryOrder',
    REQUEST_PAYMENT: '/pay/createOrder',
    QUERY_PAYMENT: '/pay/queryOrder',
  },
};
